import { MatMenuTrigger } from '@angular/material';

export class HoverMenuHelper {
  private menuCloseTimeout: any = null;
  private currentTrigger: MatMenuTrigger | null = null;

  public openMenuOnHover(trigger: MatMenuTrigger): void {
    if (trigger) {
      this.currentTrigger = trigger;
    }
    if (!this.currentTrigger || this.isTriggerDisabled(this.currentTrigger)) {
      return;
    }
    this.cancelMenuClose();
    if (!this.currentTrigger.menuOpen) {
      this.currentTrigger.openMenu();
    }
  }

  public closeMenuOnLeave(trigger?: MatMenuTrigger): void {
    const targetTrigger = trigger || this.currentTrigger;
    this.cancelMenuClose();
    this.menuCloseTimeout = setTimeout(() => {
      if (targetTrigger && targetTrigger.menuOpen) {
        targetTrigger.closeMenu();
      }
    }, 150);
  }

  public cancelMenuClose(): void {
    if (this.menuCloseTimeout) {
      clearTimeout(this.menuCloseTimeout);
      this.menuCloseTimeout = null;
    }
  }

  public destroy(): void {
    this.cancelMenuClose();
    this.currentTrigger = null;
  }

  private isTriggerDisabled(trigger: MatMenuTrigger): boolean {
    const triggerAny = trigger as any;
    if (triggerAny.menuDisabled || triggerAny.disabled) {
      return true;
    }
    const nativeElement = triggerAny._element && triggerAny._element.nativeElement;
    if (nativeElement) {
      return (
        !!nativeElement.disabled ||
        nativeElement.hasAttribute('disabled') ||
        nativeElement.getAttribute('aria-disabled') === 'true' ||
        (nativeElement.classList && nativeElement.classList.contains('mat-button-disabled'))
      );
    }
    return false;
  }
}
